import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { FavouriteType } from '@frontend/sports/favourites/core/feature';
import { FavouriteToggleComponent, FavouriteToggleTracking } from '@frontend/sports/favourites/feature/toggle';
import { TrackingSource, trackingConstants } from '@frontend/sports/tracking/feature';

@Component({
    selector: 'ms-favourite-league-toggle',
    template: `
        <ms-favourite-toggle
            [id]="id.toString()"
            [name]="name"
            [sport]="sport"
            [favIconSize]="favToggleIconSize"
            [type]="type"
            [static]="static"
            [tracking]="favouriteTracking"
            (toggle)="toggle.emit($event)" />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FavouriteToggleComponent],
})
export class FavouriteLeagueToggleComponent {
    @Input() id: string | number;
    @Input() name: string;
    @Input() sport: number;
    @Input() static: boolean;
    @Input() favToggleIconSize = '16';
    @Input() tracking: TrackingSource;
    @Output() toggle = new EventEmitter<boolean>();

    type = FavouriteType.League;

    get favouriteTracking(): FavouriteToggleTracking {
        return {
            name: this.name,
            additional: {
                [trackingConstants.SPORT_ID]: this.sport.toString(),
                [trackingConstants.SPORT_LEAGUE_ID]: this.id.toString(),
            },
            ...this.tracking,
        };
    }
}
